import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";

import { EMPTY_STRING, transactionConstants } from "../../../../constants";
import EditTradeBatchOfferModal from "../AddTradeBatch/EditTradeBatchOfferModal";
import {
  parseToDecimalNumber,
  parseToThousandSeperatorDecimalNumber,
} from "../../../../shared/utility";
import {
  UnLinkIcon,
  LinkIcon,
  ResetCartIcon,
  EditIcon,
} from "../../../../assets/icons/iconsProvider";

const EditTradeBatchOffer = ({
  data,
  setIsLink,
  isLink = true,
  handleRefresh,
  handleCashChange,
  handleTradeChange,
  cashTradeOfferValue,
  addTradeBatchInventory,
}) => {
  // useState
  const [isEditOfferModalOpen, setIsEditOfferModalOpen] =
    useState(EMPTY_STRING);

  const offerPercentages = {
    cashOfferPercentage:
      (data?.totalMarketPrice &&
        (cashTradeOfferValue?.cashOfferValue / data?.totalMarketPrice) * 100) ||
      0,
    tradeOfferPercentage:
      (data?.totalMarketPrice &&
        (cashTradeOfferValue?.tradeOfferValue / data?.totalMarketPrice) *
          100) ||
      0,
  };

  const isDisabled = !addTradeBatchInventory?.length;

  //-------open edit offer modal
  const toggleEditOfferModal = (value) => setIsEditOfferModalOpen(value);
  return (
    <Row className="h-100 w-100 edit-total-cash-trade-wrapper ">
      <Col
        sm={12}
        className="d-flex align-items-center justify-content-between mb-2"
      >
        <span className="batch-edit-offer-heading">Total Offer</span>
        <button
          className={`action-Button-Wrapper ps-0 pe-0 reset-total-button`}
          onClick={() => handleRefresh()}
          disabled={isDisabled}
        >
          <ResetCartIcon className={`link-unlink-button-icon`} />
        </button>
      </Col>
      <Col
        sm={12}
        className="d-flex justify-content-center align-items-center gap-4"
      >
        <div className="w-100">
          <Row className="m-0">
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center px-0 position-relative"
            >
              <span className="edit-trade-batch-offer-field-heading">Cash</span>
              <button
                className="action-Button-Wrapper ps-0 pe-0 reset-total-button cursor-none"
                onClick={() => {
                  toggleEditOfferModal(
                    transactionConstants.EDIT_CASH_OFFER_MODAL
                  );
                }}
                disabled={isDisabled}
              >
                <EditIcon className=" link-unlink-button-icon" />
              </button>
              {isEditOfferModalOpen ===
              transactionConstants.EDIT_CASH_OFFER_MODAL ? (
                <EditTradeBatchOfferModal
                  data={data}
                  handleSubmit={handleCashChange}
                  headingLabel={"Edit Total Cash Offer"}
                  value={cashTradeOfferValue.cashOfferValue}
                  isEditOfferModalOpen={isEditOfferModalOpen}
                  toggleEditOfferModal={toggleEditOfferModal}
                  percentage={offerPercentages?.cashOfferPercentage}
                />
              ) : (
                ""
              )}
            </Col>
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center mt-1  px-0"
            >
              <span className="edit-trade-batch-offer-field">
                $
                {parseToThousandSeperatorDecimalNumber(
                  cashTradeOfferValue.cashOfferValue || 0
                )}
                <span className="ms-2">
                  (
                  {`${parseToDecimalNumber(
                    offerPercentages?.cashOfferPercentage || 0
                  )} %`}
                  )
                </span>
              </span>
            </Col>
          </Row>
        </div>
        <div className="d-flex justify-content-center align-items-end h-100 pb-3">
          <button
            className="action-Button-Wrapper ps-0 pe-0 reset-total-button"
            onClick={() => {
              setIsLink(!isLink);
            }}
          >
            {isLink ? (
              <LinkIcon className=" link-unlink-button-icon" />
            ) : (
              <UnLinkIcon className=" link-unlink-button-icon" />
            )}
          </button>
        </div>
        <div className="w-100">
          <Row className="m-0">
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center px-0 position-relative"
            >
              <span className="edit-trade-batch-offer-field-heading">
                Trade
              </span>
              <button
                className="action-Button-Wrapper ps-0 pe-0 reset-total-button"
                onClick={() => {
                  toggleEditOfferModal(
                    transactionConstants.EDIT_TRADE_OFFER_MODAL
                  );
                }}
                disabled={isDisabled}
              >
                <EditIcon className=" link-unlink-button-icon" />
              </button>
              {isEditOfferModalOpen ===
              transactionConstants.EDIT_TRADE_OFFER_MODAL ? (
                <EditTradeBatchOfferModal
                  data={data}
                  handleSubmit={handleTradeChange}
                  percentage={offerPercentages?.tradeOfferPercentage}
                  className={"edit-trade-offer-modal"}
                  value={cashTradeOfferValue.tradeOfferValue}
                  headingLabel={"Edit Total Trade Offer"}
                  isEditOfferModalOpen={isEditOfferModalOpen}
                  toggleEditOfferModal={toggleEditOfferModal}
                />
              ) : (
                ""
              )}
            </Col>
            <Col
              md={12}
              className="d-flex justify-content-between align-items-center mt-1  px-0"
            >
              <span className="edit-trade-batch-offer-field">
                $
                {parseToThousandSeperatorDecimalNumber(
                  cashTradeOfferValue.tradeOfferValue || 0
                )}
                <span className="ms-2">
                  (
                  {`${parseToDecimalNumber(
                    offerPercentages?.tradeOfferPercentage || 0
                  )} %`}
                  )
                </span>
              </span>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
};

export default EditTradeBatchOffer;
